import { ReadOnly as ReadOnlyComponent } from '@ui-framework/index';
import { Paper, Box } from '@mui/material';

function ReadOnly({ name, value }) {
  return (
    <ReadOnlyComponent name={name} component="div">
      <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
        <Box
          component="pre"
          sx={{
            m: 0,
            p: 1,
            maxHeight: 'min(40vh, 250px)',
            overflow: 'auto',
            fontSize: theme => theme.typography.caption.fontSize,
            fontFamily: 'ui-monospace, monospace',
            cursor: 'default',
          }}>
          {value}
        </Box>
      </Paper>
    </ReadOnlyComponent>
  );
}

export default ReadOnly;
